import { render } from "./indicators_list_tab.vue?vue&type=template&id=1dc61ecc"
import script from "./indicators_list_tab.vue?vue&type=script&lang=js"
export * from "./indicators_list_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__